import gql from 'graphql-tag';
export const UpdateEntity = gql`
  mutation UpdateEntity(
    $entityId: String!
    $timestamp: Long
    $properties: JSON
  ) {
    updateEntity(
      entityId: $entityId
      timestamp: $timestamp
      properties: $properties
    ) {
      vertex {
        id
        properties
        entity {
          _id
          _key
          _class
          _type
          _latest
          _source
          _accountId
          _integrationName
          _integrationDefinitionId
          _integrationInstanceId
          _version
          _createdOn
          _beginOn
          _endOn
          _deleted
          displayName
        }
      }
    }
  }
`;

export const DeleteEntity = gql`
  mutation DeleteEntity(
    $entityId: String!
    $timestamp: Long
    $hardDelete: Boolean
  ) {
    deleteEntityV2(
      entityId: $entityId
      timestamp: $timestamp
      hardDelete: $hardDelete
    ) {
      entity
    }
  }
`;
